<script>
import RoomInfoDetails from '@components/room-info-details'

export default {
  components: { RoomInfoDetails },
  props: {
    room: { type: Object, required: true },
  },
  data: () => ({
    showModal: false,
  }),
  computed: {
    heroImg() {
      const images = this.room.images
      return images.length ? images[0].src : ''
    },
  },
}
</script>

<template>
  <div class="w-full md:w-3/12 px-3">
    <div class="relative overflow-hidden my-3 cursor-pointer h-64 md:h-40">
      <img
        :src="heroImg"
        :alt="room.name"
        class="max-w-full w-full max-h-full h-full absolute inset-0"
        @click="showModal = true"
      />
    </div>
    <div>
      <a
        class="hidden md:inline-block mb-3 text-sm text-blue-500 cursor-pointer hover:underline"
        @click="showModal = true"
      >
        Room photos and details
      </a>
      <ul class="flex flex-wrap text-sm leading-relaxed">
        <li v-if="room.information.wifiIncluded" class="w-1/2 md:w-full mb-3">
          <div class="flex">
            <BaseIcon class="fa-fw mr-3 text-lg text-gray-600" name="wifi" />
            Free Wi-Fi
          </div>
        </li>
        <li class="w-1/2 md:w-full mb-3">
          <div class="flex">
            <BaseIcon class="fa-fw mr-3 text-lg text-gray-600" name="home" />
            Area size: {{ room.information.sizeSqm }} m²
          </div>
        </li>
        <li class="w-1/2 md:w-full mb-3">
          <div class="flex">
            <BaseIcon class="fa-fw mr-3 text-lg text-gray-600" name="bed" />
            {{ room.information.bedType }}
          </div>
        </li>
        <li class="w-1/2 md:w-full mb-3">
          <div class="flex">
            <BaseIcon
              class="fa-fw mr-3 text-lg text-gray-600"
              name="mountain"
            />
            {{ room.information.view }}
          </div>
        </li>
        <li class="w-1/2 md:w-full mb-3">
          <div class="flex">
            <BaseIcon class="fa-fw mr-3 text-lg text-gray-600" name="bath" />
            {{ room.information.bathroom }}
          </div>
        </li>
      </ul>
      <a
        class="inline-block mb-3 text-sm text-blue-500 cursor-pointer hover:underline"
        @click="showModal = true"
      >
        More features...
      </a>
    </div>

    <RoomInfoDetails v-model="showModal" :room="room" />
  </div>
  <!-- room image -->
</template>
